import { FilterOperator } from './operators';
import { SearchValueType } from './search-value-type';
import { SubConditionFilterModel } from 'src/app/shared/odata-filter-models/sub-condition-filter-model';

export interface ODataFilter {
  childFieldName: string;
  filterGroup: FilterGroup;
  displayName: string;
  targetField: string;
  targetFieldId: string;
  valueType: SearchValueType;
  subFilter: ODataSubFilter;
  values?: any[];
  secondFilter?: any;
  buildFilter(
    searchValue: any,
    filterOperator: FilterOperator,
    subQueryFilters?: any[],
    buildForAutomation?: boolean
  ): any;
}

export class ODataFilterValues {
  constructor(
    public searchValue: any,
    public name: string
  ) {}
}

export enum FilterGroup {
  SystemFields = 'System Fields',
  SystemChildFields = 'System Child Fields',
  PersonCustomFields = 'Person Custom Fields',
  PersonSkills = 'Person Skills',
  TeamCustomFields = 'Team Custom Fields',
  TrackedFields = 'Tracked Fields',
  TeamExperienceFields = 'Team Experience Fields',
  SurveyQuestions = 'Survey Questions',
  EvaluationQuestions = 'Evaluation Questions',
  SubConditionFilterFields = 'Sub Condition Filter Fields',
  PersonComplexFields = 'Person Complex Fields',
  RegularRequirements = 'Regular Requirements',
  PaymentRequirements = 'Payment Requirements',
  CredentialScenarios = 'Credential Scenarios'
}

export enum FilterUIType {
  DropDown,
  Multiselect,
  DatePicker,
  Textbox
}

export class ODataSubFilter {
  constructor(public filters?: SubConditionFilterModel[]) {
    this.filters = filters || [];
  }
}
